import { render } from "./actionJavascriptComponent.vue?vue&type=template&id=2f2fc7c7"
import script from "./actionJavascriptComponent.vue?vue&type=script&lang=js"
export * from "./actionJavascriptComponent.vue?vue&type=script&lang=js"

import "./actionJavascriptComponent.vue?vue&type=style&index=0&id=2f2fc7c7&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__